import React from 'react';
export function Footer() {
  return <footer className="bg-void py-12 relative" data-id="element-313">
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-cinema via-music to-social opacity-50" data-id="element-314"></div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row justify-between items-center pt-8" data-id="element-315">
        <div className="mb-8 md:mb-0 text-center md:text-left" data-id="element-316">
          <h2 className="text-title font-serif text-gradient-gold tracking-widest uppercase mb-2" data-id="element-317">
            QUBIX
          </h2>
          <p className="text-silver text-sm tracking-wide italic" data-id="element-318">
            We don't install systems. We design how your home feels.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-6 mb-8 md:mb-0" data-id="element-319">
          {['Experience', 'Spaces', 'Systems', 'Projects', 'Contact'].map(link => <a key={link} href={`#${link.toLowerCase()}`} className="text-silver hover:text-white text-sm uppercase tracking-widest transition-colors" data-id="element-320">
                {link}
              </a>)}
        </div>

        <div className="text-ash text-xs tracking-widest uppercase" data-id="element-321">
          &copy; {new Date().getFullYear()} QUBIX. All rights reserved.
        </div>
      </div>
    </footer>;
}